<template>
  <table class="rtable table-auto w-[calc(100%+2rem)] mx-[-1rem]">
    <thead>
      <tr>
        <slot name="head"></slot>
      </tr>
    </thead>
    <slot name="main"></slot>
    <tbody>
      <slot name="body"></slot>
    </tbody>
  </table>
</template>

<style lang="scss">
table.rtable {
  thead tr {
    th {
      @apply text-left py-2 px-4 font-bold;

      &:last-child {
        @apply pr-4;
      }

      &:first-child {
        @apply pl-4;
      }
    }
  }

  tbody {
    tr {
      &:nth-child(2n + 1) {
        td {
          @apply bg-grey-5 dark:bg-grey-80;
        }
      }

      &.has-hover:hover {
        cursor: pointer;

        td {
          @apply bg-grey-10 dark:bg-grey-70;
        }
      }

      td {
        @apply text-left py-2 px-4;

        &:last-child {
          @apply rounded-r-lg pr-4;
        }

        &:first-child {
          @apply rounded-l-lg pl-4;
        }
      }
    }
  }
}
</style>
